import moment from 'moment';

export function convertTelFomat(phoneNumber) {

    phoneNumber = phoneNumber.replace(/[^0-9]/g, "");

    let res ='';

    if(!phoneNumber) return res

    if(phoneNumber.length < 3) {
        res = phoneNumber
    }
    else {
        if(phoneNumber.substr(0, 2) =='02') {

            if(phoneNumber.length <= 5) {//02-123-5678
                res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3)
            }
            else if(phoneNumber.length > 5 && phoneNumber.length <= 9) {//02-123-5678
                res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3) + '-' + phoneNumber.substr(5)
            }
            else if(phoneNumber.length > 9) {//02-1234-5678
                res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 4) + '-' + phoneNumber.substr(6)
            }

        } else {
            if(phoneNumber.length < 8) {
                res = phoneNumber
            }
            else if(phoneNumber.length == 8)
            {
                res = phoneNumber.substr(0, 4) + '-' + phoneNumber.substr(4)
            }
            else if(phoneNumber.length == 9)
            {
                res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6)
            }
            else if(phoneNumber.length == 10)
            {
                res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6)
            }
            else if(phoneNumber.length > 10) { //010-1234-5678
                res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 4) + '-' + phoneNumber.substr(7)
            }
        }
    }
            
    return res;

}

export function convertDateFormat(date, type){
    switch(type){
        case 'none' : return moment(date).format('YYYYMMDD');
        case 'hyphen' : return moment(date).format('YYYY-MM-DD');
        case 'dot' : return moment(date).format('YYYY.MM.DD');
        case 'kor' : return moment(date).format('YYYY년 MM월 DD일');
        case 'date' : return moment(date).format('A hh:mm');
        case 'chip' : return moment(date).format('YY.MM.DD');
        default : return date;
    }
}

export function convertShortCity(city){
    switch(city){
        case "서울특별시" : return "서울";
        case "부산광역시" : return "부산";
        case "대구광역시" : return "대구";
        case "인천광역시" : return "인천";
        case "광주광역시" : return "광주";
        case "세종특별자치시" : return "세종";
        case "대전광역시" : return "대전";
        case "울산광역시" : return "울산";
        case "경기도" : return "경기";
        case "강원도" : case '강원특별자치도' : return "강원";
        case "충청북도" : return "충북";
        case "충청남도" : return "충남";
        case "전라북도" : case '전북특별자치도' : return "전북";
        case "전라남도" : return "전남";
        case "경상북도" : return "경북";
        case "경상남도" : return "경남";
        case "제주특별자치도" : return "제주";
        default : return city;
    }
}

//업데이트 전까지는 지역명이 변경된 지역을 이전 지역으로 변경해서 호출
export function convertTempCityName(city){
    switch(city){
        case '강원특별자치도' : return '강원도';
        case '전북특별자치도' : return '전라북도';
        default : return city;
    }

}

export function isNotifyEnd(notify_edt) {
    // 오늘 날짜를 'YYYYMMDD' 형식으로 얻기
    const today = new Date();
    const todayStr = today.getFullYear().toString() +
                    String(today.getMonth() + 1).padStart(2, '0') +
                    String(today.getDate()).padStart(2, '0');

    // 날짜 비교
    return notify_edt < todayStr;
}

export function convertNotifyState(animal){

    let notify_state = "";
    let class_name = "";

    switch(animal.state){
    case '보호중': 
        isNotifyEnd(animal.notify_edt) ? notify_state = '보호중' : notify_state = '공고중' ;
        class_name = 'state-protect';
        break;
    case '종료(기증)': 
        notify_state = '완료';
        class_name = 'state-complete';
        break;
    case '종료(반환)': 
        notify_state = '완료';
        class_name = 'state-complete';
        break;
    case '종료(입양)': 
        notify_state = '완료';
        class_name = 'state-complete';
        break;
    case '종료(자연사)': 
        notify_state = '완료';
        class_name = 'state-complete';
        break;
    case '종료(안락사)': 
        notify_state = '완료';
        class_name = 'state-complete';
        break;
    }

    let notify_info = {
        class_name : class_name,
        notify_state : notify_state
    }

    return notify_info;
}

export function convertAnimalSex(animal){
    let sex_kor = "";
    let class_name = "";

    switch(animal.sex){
    case 'M': 
        sex_kor = "수컷";
        class_name = "male";
        break;
    case 'F': 
        sex_kor = "암컷";
        class_name = "female";
        break;
    case 'Q': 
        sex_kor = "성별미상";
        class_name = "unknown";
        break;
    }

    let sex_info = {
    sex_kor : sex_kor,
    class_name : class_name,
    };

    return sex_info;
}

export function convertShortCountry(country){
    if(country.length >= 3){
    if(country.indexOf('시') || country.indexOf('군') || country.indexOf('구')){

        if(country == '세종특별자치시' || country == '제주특별자치도' || country == '창원마산합포회원구' || country == '창원의창성산구' || country == '창원진해구'){
        country = country.substr(0, 2);

        return country;
        }
        country = country.slice(0, -1);

        return country;
    }
    }else{
    return country;
    }
}

/* Detail */

export function convertAnimalState(animal){
    switch(animal.state){
        case '종료(입양)' : return '완료(입양)';
        case '종료(반환)' : return '완료(귀가)';
        case '종료(기증)' : return '완료(기증)';
        default : return animal.state;
    }
}

export function convertStateStyle(animal){
    
    if(animal.state === '종료(입양)'){
        return 'bg-alpha-blue';
    }else if(animal.state.includes('종료')){
        return 'bg-alpha-gray';
    }else{
        return 'bg-alpha-green';
    }
}

export function convertAnimalInfoText(animal){

    let sex;
    let neutral;

    switch(animal.sex){
        case 'F' : sex = '암컷'; break;
        case 'M' : sex = '수컷'; break;
        case 'Q' : sex = '성별미상'; break;
    }

    switch(animal.neutral){
        case 'Y' : neutral = 'O'; break;
        case 'N' : neutral = 'X'; break;
        case 'U' : neutral = '미확인'; break;
    }

    return sex + '(중성화 ' + neutral + ')' + ' / ' + animal.color + ' / ' + animal.age + ' / ' + animal.weight
}

export function convertMedicalStyle(medicalItem){
    switch(medicalItem){
        case '음성' : return 'fc-green';
        case '양성' : return 'fc-red'; 
        default : return 'fc-deep-gray';
    }
}

/* lostinfo */
export function convertLostStateClass(state){
    switch(state){
        case '목격' : return 'bg-blue fc-white';
        case '실종' : return 'bg-red fc-white';
        case '완료' : return 'bg-deep-gray fc-white';
        default : return 'bg-deep-gray fc-white';
    }
}

/** 문자열/숫자/Date를 Date로 안전 파싱 */
function parseToDate(input) {
  if (input instanceof Date) return input;
  if (typeof input === 'number') return new Date(input);

  if (typeof input === 'string') {
    const s = input.trim();

    // yyyymmdd or yyyymmddHHMMss 지원
    if (/^\d{8}$/.test(s)) {
      const y = +s.slice(0, 4), m = +s.slice(4, 6) - 1, d = +s.slice(6, 8);
      return new Date(y, m, d);
    }
    if (/^\d{14}$/.test(s)) {
      const y = +s.slice(0, 4), m = +s.slice(4, 6) - 1, d = +s.slice(6, 8);
      const hh = +s.slice(8, 10), mm = +s.slice(10, 12), ss = +s.slice(12, 14);
      return new Date(y, m, d, hh, mm, ss);
    }

    // "YYYY-MM-DD HH:mm:ss" -> "YYYY-MM-DDTHH:mm:ss"
    const isoish = s.includes(' ') && !s.includes('T') ? s.replace(' ', 'T') : s;
    let d = new Date(isoish);
    if (!Number.isNaN(d.getTime())) return d;

    // 대체 파서 (하이픈을 슬래시로 교체)
    d = new Date(s.replace(/-/g, '/'));
    if (!Number.isNaN(d.getTime())) return d;
  }

  return new Date(NaN);
}

/** 간단한 날짜 포맷터 (지원 토큰: YYYY, MM, DD, HH, mm) */
function formatDate(date, fmt = 'YYYY-MM-DD') {
  const pad = (n) => String(n).padStart(2, '0');
  const Y = date.getFullYear();
  const M = pad(date.getMonth() + 1);
  const D = pad(date.getDate());
  const H = pad(date.getHours());
  const m = pad(date.getMinutes());
  return fmt
    .replace('YYYY', Y)
    .replace('MM', M)
    .replace('DD', D)
    .replace('HH', H)
    .replace('mm', m);
}

/**
 * 1시간 이내 → "n분 전"
 * 24시간 이내 → "n시간 전"
 * 그 이상 → 날짜(기본 'YYYY-MM-DD')
 */
export function timeAgoKo(input, opts = {}) {
  const { now = new Date(), dateFormat = 'YYYY-MM-DD' } = opts;

  const date = parseToDate(input);
  const ts = date.getTime();
  if (Number.isNaN(ts)) return ''; // 파싱 실패 시 빈 문자열(원하면 그대로 리턴하도록 변경)

  let diff = now.getTime() - ts; // ms
  if (diff < 0) diff = 0; // 미래시각이면 0으로 클램프

  const sec = Math.floor(diff / 1000);
  const min = Math.floor(sec / 60);
  const hour = Math.floor(min / 60);

  if (hour < 1) {
    const m = Math.max(1, min);     // 0분 전 대신 1분 전으로 보정 (원하면 '방금 전'로 처리)
    return `${m}분 전`;
  }
  if (hour < 24) {
    return `${hour}시간 전`;
  }
  return formatDate(date, dateFormat);
}

export const formatNumber = (v) =>
  (v === null || v === undefined || v === '') ? '0' : Number(v).toLocaleString('ko-KR');